import { useSyncExternalStore } from 'react';

/**
 * AL.E4 (AUD.24) — PROJETO GLOBAL: um seletor só, no header do produto, que `/backlog`, `/central` (destino do
 * apontamento) e `/evidence` leem como escolha inicial. Antes cada tela tinha o seu, e o dono reescolhia o mesmo
 * projeto três vezes. Persistido por viewer (`localStorage`), nunca lido pelo servidor.
 */
const KEY = 'td_global_project';
const EVENT = 'td:global-project';
const listeners = new Set<() => void>();

export function getGlobalProject(): string {
  try {
    return window.localStorage.getItem(KEY) ?? '';
  } catch {
    return '';
  }
}

export function setGlobalProject(cwd: string): void {
  try {
    if (cwd) window.localStorage.setItem(KEY, cwd);
    else window.localStorage.removeItem(KEY);
  } catch {
    /* storage indisponível: a escolha vale só para esta página */
  }
  for (const l of listeners) l();
  try {
    window.dispatchEvent(new CustomEvent(EVENT));
  } catch {
    /* ambiente sem CustomEvent */
  }
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  const onStorage = (e: StorageEvent): void => {
    if (e.key === KEY) cb();
  };
  window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(cb);
    window.removeEventListener('storage', onStorage);
  };
}

/** O header já renderiza o seletor (lista carregada)? As telas escondem o seletor próprio no desktop quando sim. */
let available = false;
export function markGlobalProjectAvailable(value: boolean): void {
  if (available === value) return;
  available = value;
  for (const l of listeners) l();
}
export function useGlobalProjectAvailable(): boolean {
  return useSyncExternalStore(subscribe, () => available, () => false);
}

/** Hook: o cwd escolhido no header ('' = nenhum). */
export function useGlobalProject(): string {
  return useSyncExternalStore(subscribe, getGlobalProject, () => '');
}
